import { jsx } from 'react/jsx-runtime';
import React, { useCallback, useMemo, useContext } from 'react';
import { Env } from '../helpers/infra.esm.js';
import { buildServiceUrl } from '../helpers/envs.esm.js';

var InfraContext = /*#__PURE__*/ React.createContext({
    env: Env.Development,
    envId: "",
    service: "",
    getServiceUrl: function() {
        return "";
    }
});
var InfraProvider = function(param) {
    var children = param.children, env = param.env, envId = param.envId, service = param.service;
    var getServiceUrl = useCallback(function(edgeService, path) {
        return buildServiceUrl(env, envId, edgeService, path !== null && path !== void 0 ? path : "");
    }, [
        env,
        envId
    ]);
    var value = useMemo(function() {
        return {
            env: env,
            envId: envId,
            service: service,
            getServiceUrl: getServiceUrl
        };
    }, [
        env,
        envId,
        service,
        getServiceUrl
    ]);
    return /*#__PURE__*/ jsx(InfraContext.Provider, {
        value: value,
        children: children
    });
};
function useInfraContext() {
    return useContext(InfraContext);
}

export { InfraContext, InfraProvider, useInfraContext };
